import { v4 as uuidv4 } from 'uuid';
import { GeoJson } from '@ais-ui/api-spec/shapes';

export const latLonToShape = (latitude: number, longitude: number): GeoJson => {
  return {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [longitude, latitude],
    },
    properties: { id: uuidv4() },
  };
};
